import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { BackendService } from '../backend/backend.service';
import { catchError, tap, throwError } from 'rxjs';
import { IConfig } from '../../../shared/model/i-config';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  http = inject(HttpClient);
  storage = inject(StorageService);
  backend = inject(BackendService);
  
  configuration: IConfig | any;

  constructor() { 
    if(!!sessionStorage.getItem("CONFIGURATION")){
      this.configuration = JSON.parse(sessionStorage.getItem("CONFIGURATION") as string);
    }
  }

  setConfig(){
    return this.http.get(`${this.backend.getApiUrl()}/profile/configuration`).pipe(
      tap( (config: any) =>{
        this.configuration = config;
        this.storage.set('CONFIGURATION', this.configuration);
      }),
      catchError( this.errorHandler.bind(this) )
    );
  }

  clearConfig(){
    this.configuration = [];
  }

  private errorHandler(error: HttpErrorResponse) {  
    return throwError(() => error.message)
  }
}
